import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=6453db82&"
import script from "./Input.vue?vue&type=script&lang=ts&"
export * from "./Input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6453db82')) {
      api.createRecord('6453db82', component.options)
    } else {
      api.reload('6453db82', component.options)
    }
    module.hot.accept("./Input.vue?vue&type=template&id=6453db82&", function () {
      api.rerender('6453db82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/Field/Input.vue"
export default component.exports